module.exports = __webpack_public_path__ + "media/icons/trash-fbe6224b1c44d7e28b4cef421f7ccd05.svg";